import { Container } from 'react-bootstrap';
import './assets/css/style.scss';
import ActivityDetails from '../../../ActivityDetails/ActivityDetails';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ActivityCategoriesStrapi, ActivityStrapi } from '../../../../shared/interfaces';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

type PagesGridProps = {
  activityList: ActivityStrapi[];
};

function PagesGrid({ activityList }: PagesGridProps) {
  const [showModal, setShowModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState<ActivityStrapi | undefined>();
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);
  const [filteredActivities, setFilteredActivities] = useState<ActivityStrapi[]>(activityList);
  const [categories, setCategories] = useState<ActivityCategoriesStrapi[] | undefined>();
  const navigate = useNavigate();
  const location = useLocation();

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get('id');

    if (id !== null) {
      const found = activityList.find((i) => i.id === parseInt(id));
      if (found) {
        setSelectedActivity(found);
        setShowModal(true);
      }
    } else {
      setShowModal(false);
      setSelectedActivity(undefined);
    }
  }, [activityList, location.search]);

  const handleOpenModal = (id: number) => {
    navigate(`${location.pathname}?id=${id}`, { replace: false });
  };

  const handleCloseModal = () => {
    navigate(location.pathname, { replace: false });
    setShowModal(false);
    setSelectedActivity(undefined);
  };

  useEffect(() => {
    fetch(`https://strapi-production-a706.up.railway.app/api/activity-categories`)
      .then((res) => res.json())
      .then((data) => setCategories(data.data))
      .catch((err) => console.error(err));

    console.log("AGON")
    console.log(activityList)
    setFilteredActivities(activityList);
  }, [activityList]);

  const handleCategoryClick = (categoryId: number | null) => {
    setSelectedCategoryId(categoryId);

    if (categoryId === null) {
      setFilteredActivities(activityList);
    } else {
      const filtered = activityList.filter((activity) =>
        activity?.activity_categories?.some(
          (cat: ActivityCategoriesStrapi) => cat.id === categoryId,
        ),
      );
      setFilteredActivities(filtered);
    }
  };

  return (
    <div className="section pagesgrid" id={'aktivitetet'}>
      <Container>
        <div className="section__title">
          <div className="section__label">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="15"
              viewBox="0 0 25 15"
              fill="none"
            >
              <g clipPath="url(#clip0_18_208)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M24.5 0.0145264L16.8419 14.9856H9.64869L12.8538 8.781H12.7098C10.0659 12.213 6.12083 14.4725 0.5 14.9856V8.86682C0.5 8.86682 4.09578 8.65434 6.20975 6.4319H0.5V0.0148545H6.91705V5.2927L7.061 5.29209L9.68328 0.0148545H14.5365V5.25937L14.6804 5.25909L17.4011 0.0145264H24.5Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_18_208">
                  <rect
                    width="24"
                    height="14.971"
                    fill="white"
                    transform="translate(0.5 0.0145264)"
                  />
                </clipPath>
              </defs>
            </svg>
            <div className="section__label-text">Aktivizem</div>
          </div>
          <h2>Aktivitetet tona</h2>
        </div>

        <div className="pagesgrid__tabs-wrapper">
          <div className="pagesgrid__tabs">
            <div
              className={`pagesgrid__tabs-item ${selectedCategoryId === null ? 'active' : ''}`}
              onClick={() => handleCategoryClick(null)}
            >
              <span>Të gjitha</span>
            </div>
            {categories?.map((category) => (
              <div
                key={category.id}
                className={`pagesgrid__tabs-item ${selectedCategoryId === category.id ? 'active' : ''}`}
                onClick={() => handleCategoryClick(category.id)}
              >
                <span>{category?.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="section__content">
          <Carousel
            responsive={responsive}
            infinite={false}
            arrows={true}
            autoPlay={false}
            draggable={true}
            keyBoardControl={true}
            showDots={true}
            containerClass="pagesgrid__carousel"
          >
            {filteredActivities?.map((activity, index) => (
              <div className="pagesgrid__carousel-item" key={index}>
                <div className="pagesgrid__grid-item">
                  <div
                    className="pagesgrid__grid-item-image"
                    onClick={() => handleOpenModal(activity.id)}
                  >
                    <img
                      src={activity?.mainImage?.url}
                      alt={`activity-${index}`}
                    />
                  </div>
                  <div className="pagesgrid__grid-item-title">
                    <h3 onClick={() => handleOpenModal(activity.id)}>
                      <span>{activity?.title}</span>
                    </h3>
                    <p>
                      {activity?.description?.length > 300
                        ? activity?.description.substring(0, 300) + '...'
                        : activity?.description}
                    </p>
                  </div>
                  <div className="pagesgrid__grid-item-categories">
                    {activity?.activity_categories?.map(
                      (cat: ActivityCategoriesStrapi) => (
                        <div
                          key={cat?.id}
                          className={`pagesgrid__grid-item-categories-item ${cat?.name.toLowerCase()}`}
                        >
                          <span>{cat?.name}</span>
                        </div>
                      ),
                    )}
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </Container>

      <ActivityDetails show={showModal} activity={selectedActivity} onClose={handleCloseModal} />
    </div>
  );
}

export default PagesGrid;
